module.exports = __webpack_public_path__ + "static/solution-section-antivirus-tab-49cbf5988eac0eca47c4fc00e77f755a.webp";